import {Component, Input, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';

export interface ApiJoinsOptions {
  editEnabled: boolean;
  deleteEnabled: boolean;
  approvalRequired: boolean;
  approvalType: string;
  minimumApprovals?: number;
  approvers?: {
    email: string;
  }[];
}

@Component({
  selector: 'api-joins-settings',
  templateUrl: './api-joins-additional-settings.component.html',
  styleUrls: ['./api-joins-additional-settings.component.scss']
})
export class ApiJoinsAdditionalSettingsComponent implements OnInit {
  @Input() options: any = {
    editEnabled: false,
    deleteEnabled: false,
    approvalRequired: false,
    approvalType: 'single',
    minimumApprovals: 1,
    approvers: []
  };

  componentLoading = true;

  approvalTypes = [
    {
      displayName: 'Require at least one approver to approve',
      value: 'single',
    },
    {
      displayName: 'Require all approvers to approve',
      value: 'unanimous',
    },
    {
      displayName: 'Customized: Specify the minimum number of approvers required',
      value: 'quorum',
    }
  ];
  separatorKeysCodes: number[] = [13, 188];
  ctrl = new FormControl();

  addApprover(email: string): void {
    if (!email) {
      return;
    }
    email = email.trim();
    if (!email || !this.isValidEmail(email)) {
      return;
    }
    this.options.approvers.push({ email: email });
    this.ctrl.setValue(null);
  }
  isValidEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  removeApprover(approver) {
    const index = this.options.approvers.indexOf(approver);
    if (index >= 0) {
      this.options.approvers.splice(index, 1);
    }
  }

  ngOnInit(): void {
    if (this.options === undefined || this.options === null) {
      this.options = Object.assign({}, {
        approvalType: 'single',
        approvalRequired: false,
        approvers: [],
        deleteEnabled: false,
        editEnabled: false,
        minimumApprovals: 1
      });
    }
    if (!this.options.hasOwnProperty('editEnabled')) {
      this.options['editEnabled'] = false;
    }
    if (!this.options.hasOwnProperty('deleteEnabled')) {
      this.options['deleteEnabled'] = false;
    }
    if (!this.options.hasOwnProperty('insertEnabled')) {
      this.options['insertEnabled'] = false;
    }
    if (!this.options.hasOwnProperty('approvalRequired')) {
      this.options['approvalRequired'] = false;
    }

    if (!this.options.hasOwnProperty('approvalType') || (this.options.approvalType !== 'single' &&
        this.options.approvalType !== 'unanimous' && this.options.approvalType !== 'quorum')) {
      this.options['approvalType'] = 'single';
    }

    if (!this.options.hasOwnProperty('minimumApprovals') || !Number.isInteger(this.options.minimumApprovals) ||
        !(this.options.minimumApprovals > 0)) {
      this.options['minimumApprovals'] = 1;
    }

    if (!this.options.hasOwnProperty('approvers') || !Array.isArray(this.options.approvers)) {
      this.options['approvers'] = [];
    }

    setTimeout(() => {
      this.componentLoading = false;
    }, 1000);
  }
}
